/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_System_Source_LabelInputs */

const bn_cipher_system_source_label = /** @type {(inputs: Cipher_System_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`উৎস`)
};

const de_cipher_system_source_label = /** @type {(inputs: Cipher_System_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QUELLE`)
};

const el_cipher_system_source_label = /** @type {(inputs: Cipher_System_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ΠΗΓΗ`)
};

const en_cipher_system_source_label = /** @type {(inputs: Cipher_System_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SOURCE`)
};

const es_cipher_system_source_label = /** @type {(inputs: Cipher_System_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FUENTE`)
};

const fr_cipher_system_source_label = /** @type {(inputs: Cipher_System_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SOURCE`)
};

const hi_cipher_system_source_label = /** @type {(inputs: Cipher_System_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्रोत`)
};

const hu_cipher_system_source_label = /** @type {(inputs: Cipher_System_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FORRÁS`)
};

const id_cipher_system_source_label = /** @type {(inputs: Cipher_System_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SUMBER`)
};

const it_cipher_system_source_label = /** @type {(inputs: Cipher_System_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FONTE`)
};

const ja_cipher_system_source_label = /** @type {(inputs: Cipher_System_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソース`)
};

const ko_cipher_system_source_label = /** @type {(inputs: Cipher_System_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`원천`)
};

const nl_cipher_system_source_label = /** @type {(inputs: Cipher_System_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BRON`)
};

const pl_cipher_system_source_label = /** @type {(inputs: Cipher_System_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ŹRÓDŁO`)
};

const pt_cipher_system_source_label = /** @type {(inputs: Cipher_System_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FONTE`)
};

const ru_cipher_system_source_label = /** @type {(inputs: Cipher_System_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ИСТОЧНИК`)
};

const sv_cipher_system_source_label = /** @type {(inputs: Cipher_System_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KÄLLA`)
};

const tr_cipher_system_source_label = /** @type {(inputs: Cipher_System_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KAYNAK`)
};

const uk_cipher_system_source_label = /** @type {(inputs: Cipher_System_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ДЖЕРЕЛО`)
};

const vi_cipher_system_source_label = /** @type {(inputs: Cipher_System_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NGUỒN`)
};

const zh_cipher_system_source_label = /** @type {(inputs: Cipher_System_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`来源`)
};

const zh_hant_cipher_system_source_label = /** @type {(inputs: Cipher_System_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`來源`)
};

/**
* | output |
* | --- |
* | "SOURCE" |
*
* @param {Cipher_System_Source_LabelInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_system_source_label = /** @type {((inputs?: Cipher_System_Source_LabelInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_System_Source_LabelInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_system_source_label(inputs)
	if (locale === "de") return de_cipher_system_source_label(inputs)
	if (locale === "el") return el_cipher_system_source_label(inputs)
	if (locale === "en") return en_cipher_system_source_label(inputs)
	if (locale === "es") return es_cipher_system_source_label(inputs)
	if (locale === "fr") return fr_cipher_system_source_label(inputs)
	if (locale === "hi") return hi_cipher_system_source_label(inputs)
	if (locale === "hu") return hu_cipher_system_source_label(inputs)
	if (locale === "id") return id_cipher_system_source_label(inputs)
	if (locale === "it") return it_cipher_system_source_label(inputs)
	if (locale === "ja") return ja_cipher_system_source_label(inputs)
	if (locale === "ko") return ko_cipher_system_source_label(inputs)
	if (locale === "nl") return nl_cipher_system_source_label(inputs)
	if (locale === "pl") return pl_cipher_system_source_label(inputs)
	if (locale === "pt") return pt_cipher_system_source_label(inputs)
	if (locale === "ru") return ru_cipher_system_source_label(inputs)
	if (locale === "sv") return sv_cipher_system_source_label(inputs)
	if (locale === "tr") return tr_cipher_system_source_label(inputs)
	if (locale === "uk") return uk_cipher_system_source_label(inputs)
	if (locale === "vi") return vi_cipher_system_source_label(inputs)
	if (locale === "zh") return zh_cipher_system_source_label(inputs)
	return zh_hant_cipher_system_source_label(inputs)
});